import Base from './Base';
import WebskyServicesAnalytics from '../WebskyServicesAnalytics';
class Nas extends Base {
    constructor(orderBeforeChange, orderAfterChange) {
        super(orderBeforeChange, orderAfterChange);
    }
    createServicesTravellersMap(services = []) {
        return new Map(services.map(service => [service.product.id, new Set(service.travellers.map(traveller => traveller.id))]));
    }
    diff() {
        var _a, _b, _c, _d, _e, _f, _g;
        const added = [];
        const removed = [];
        const servicesMap = new Map(((_c = (_b = (_a = this.orderAfterChange.additionalServices) === null || _a === void 0 ? void 0 : _a.nas) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c.map(service => [service.id, service])) || []);
        const travellersMap = new Map(this.orderAfterChange.travellers.map(traveller => [traveller.id, traveller]));
        const beforeServicesTravellersIdsMap = this.createServicesTravellersMap((_e = (_d = this.orderBeforeChange.additionalServices) === null || _d === void 0 ? void 0 : _d.nas) === null || _e === void 0 ? void 0 : _e.selectedServices);
        const afterServicesTravellersIdsMap = this.createServicesTravellersMap((_g = (_f = this.orderAfterChange.additionalServices) === null || _f === void 0 ? void 0 : _f.nas) === null || _g === void 0 ? void 0 : _g.selectedServices);
        const allProductsIds = new Set([
            ...beforeServicesTravellersIdsMap.keys(),
            ...afterServicesTravellersIdsMap.keys()
        ]);
        allProductsIds.forEach(productId => {
            const nasService = servicesMap.get(productId);
            if (nasService) {
                const beforeTravellersIds = beforeServicesTravellersIdsMap.get(productId) || new Set();
                const afterTravellersIds = afterServicesTravellersIdsMap.get(productId) || new Set();
                afterTravellersIds.forEach(travellerId => {
                    if (!beforeTravellersIds.has(travellerId)) {
                        added.push(WebskyServicesAnalytics.convertNasServiceToDataLayer(nasService, this.orderAfterChange.travellers, travellersMap.get(travellerId).type));
                    }
                });
                beforeTravellersIds.forEach(travellerId => {
                    if (!afterTravellersIds.has(travellerId)) {
                        removed.push(WebskyServicesAnalytics.convertNasServiceToDataLayer(nasService, this.orderAfterChange.travellers, travellersMap.get(travellerId).type));
                    }
                });
            }
        });
        return { added, removed };
    }
}
export default Nas;
